export class InsignConnectionRequestModel {
  clientId: string;
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  title?: string;
  anonymous: boolean = false;
}

export class InsignListRequestModel {
  status: 'INITIALIZED' | 'OPEN' | 'SIGNED' | 'PARTIALLY_SIGNED' = null;
  page: number = 0;
  perPage: number = 25;
}
